// extracted by mini-css-extract-plugin
export default {"menu":"hoverMenu_menu__mXFrG","box":"hoverMenu_box__7hiSR"};